// extracted by mini-css-extract-plugin
export default {"container":"container___Pbh4N","headline":"headline___2BZwd","privacy":"privacy___3Qsk3"};